export { orchestrator } from './orchestrator';
export { default as setupRulesEngine } from './setupRulesEngine';
export * as rules from './rules';
// Exported for callers that need to see a form's record the way the save pipeline sees it -- with
// DefaultToPreviousSelection/DefaultValue restorations merged in. Every in-repo caller was a rule
// until continuous scan added a second way to "finish" a Mass Update form that never reaches one.
export { setDefaultValuesIfNecessary } from './utilities';
